import { Component, inject, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/shared/models/project';
import { TabMenuLogicService } from 'src/app/shared/services/tab-menu.logic.service';
import { Constants } from 'src/app/shared/utils/constants';
import { ERAPecEccAquaticEuColDef } from './columnDefs/era-pec-ecc-aquatic-Eu.coldef';
import { ERAPecEccAquaticUsColDef } from './columnDefs/era-pec-ecc-aquatic-Us.coldef';
import { ERAConstants } from '../../environmental-risk-assessment.constants';
import { EraPecEccAquaticEu, EraPecEccAquaticGeography, EraPecEccAquaticUs } from '../era-pec-ecc-aquatic/era-pec-ecc-aquatic.model';
import { ERAPecEccAquaticLogicService } from '../era-pec-ecc-aquatic/services/era-pec-ecc-aquatic.logic.service';
import { ERAPecEccPlantAssessmentToolTpezUsColDef } from './columnDefs/era-pec-ecc-plant-assessment-tool-Us-tpez.coldef';
import { ERAPecEccPlantAssessmentToolWpezUsColDef } from './columnDefs/era-pec-ecc-plant-assessment-tool-Us-wpez.coldef';

@Component({
  selector: 'app-era-pec-ecc',
  templateUrl: './era-pec-ecc.component.html',
  styleUrls: ['./era-pec-ecc.component.css']
})
export class ERAPecEccComponent implements OnInit {

  @Input() selectedProject?: Project;
  @Input() menuService!: TabMenuLogicService;
  @Input() isProjectOwnershipValid: boolean = false;

  public aquaticColumnDef!: any;
  public data: EraPecEccAquaticEu[] | EraPecEccAquaticUs[] = [];
  public geography: EraPecEccAquaticGeography = {} as EraPecEccAquaticGeography;
  public isLoading: boolean = false;
  public plantAssessmentToolTpezColumnDef!: any;
  public plantAssessmentToolWpezColumnDef!: any;
  public activeIndex: number | number[] = [];

  private euAquaticColumnDefsService = inject(ERAPecEccAquaticEuColDef);
  private logicService = inject(ERAPecEccAquaticLogicService);
  private usAquaticColumnDefsService = inject(ERAPecEccAquaticUsColDef);
  private usPlantAssessmentToolTpezColumnsDef = inject(ERAPecEccPlantAssessmentToolTpezUsColDef);
  private usPlantAssessmentToolWpezColumnsDef = inject(ERAPecEccPlantAssessmentToolWpezUsColDef);

  public async ngOnInit(): Promise<void> {
    this.isLoading = true;
    this.setGeographyByEnvironment();

    const {geographyName, geographyPk, geograpyType} = this.geography;
    const { projectPk } = this.selectedProject!;

    await this.logicService.getCompartments();
    await this.logicService.getModelsAndCompounds(geographyPk, geograpyType, projectPk);

    if( geographyName === Constants.GEOGRAPHYS.EUROPE_UNION ) {
      this.activeIndex = [0];
      this.logicService.setWaterbodyOptions( this.geography.geographyName );
    }

    if( geographyName ===Constants.GEOGRAPHYS.USA )
        await this.initUs();

    this.setColumnDef( this.geography.geographyName );
    this.isLoading = false;
  }

    async initUs(): Promise<void> {
      const { geographyName, geographyPk: countryPk } = this.geography;

      await this.logicService.getCropsAndRegions();
      this.logicService.setWaterbodyOptions( geographyName );
    }

  //This is needed because in prod USA is a region and in lower environments is a country
  private setGeographyByEnvironment(): void {

    if( !this.selectedProject ) return;

    const {EUROPE_UNION, USA} = Constants.GEOGRAPHYS;
    const {COUNTRY, REGION} = ERAConstants.GEOGRAPHY_TYPE;
    const {countryPk, regionPk, geography} = this.selectedProject;

    if( geography === Constants.CROP_GEOGRAPHIES.USA && !countryPk ){
      this.setGeography( geography, REGION, regionPk! );
      return;
    }

    const geographyName = countryPk ? USA : EUROPE_UNION;
    const geograpyType = countryPk ? COUNTRY : REGION;
    const geographyPk = countryPk ?? regionPk!;
    this.setGeography( geographyName, geograpyType, geographyPk );
  }

  private setGeography( geographyName: string, geographyType: string, geographyPk: number ): void {
    this.geography.geographyName = geographyName;
    this.geography.geograpyType = geographyType;
    this.geography.geographyPk = geographyPk;
  }

  private setColumnDef( geographyName: string ): void{

    if(geographyName === Constants.GEOGRAPHYS.EUROPE_UNION) {
      this.aquaticColumnDef = this.euAquaticColumnDefsService.getColumnsDefinition(this.isProjectOwnershipValid);
      return;
    }

    if(geographyName === Constants.GEOGRAPHYS.USA){
      this.plantAssessmentToolTpezColumnDef = this.usPlantAssessmentToolTpezColumnsDef.getColumnsDefinition(this.isProjectOwnershipValid);
      this.plantAssessmentToolWpezColumnDef = this.usPlantAssessmentToolWpezColumnsDef.getColumnsDefinition(this.isProjectOwnershipValid);
      this.aquaticColumnDef = this.usAquaticColumnDefsService.getColumnsDefinition(this.isProjectOwnershipValid);
    }
  }

}
